import { z } from 'zod';

// ─── Reactions ────────────────────────────────────────────────────────────────

const ALLOWED_EMOJIS = ['🔥', '💀', '😂', '🤙', '👀', '🗑️', '🤮', '💯'] as const;

export const AllowedEmojiSchema = z.enum(ALLOWED_EMOJIS);
export type AllowedEmoji = z.infer<typeof AllowedEmojiSchema>;

export const ALLOWED_EMOJIS_LIST = ALLOWED_EMOJIS;

export const AddReactionSchema = z.object({
  emoji: AllowedEmojiSchema,
  trackSessionId: z.string().uuid(),
});
export type AddReactionInput = z.infer<typeof AddReactionSchema>;

/** Aggregated reaction counts broadcast via SSE */
export const ReactionCountsSchema = z.record(AllowedEmojiSchema, z.number().int().min(0));
export type ReactionCounts = z.infer<typeof ReactionCountsSchema>;

/** SSE event payload for reaction updates */
export const ReactionUpdateSchema = z.object({
  stationSlug: z.string(),
  trackSessionId: z.string().uuid(),
  counts: ReactionCountsSchema,
});
export type ReactionUpdate = z.infer<typeof ReactionUpdateSchema>;
